import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchHandloomClusterList = ({commit}) => {

    axios.get('/handloomCluster/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setHandloomClusterList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchHandloomClusterData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/handloomCluster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});
            }
    
            commit('setHandloomClusterData', res.data.response)   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetHandloomClusterData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitHandloomClusterData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/handloomCluster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteHandloomClusterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/handloomCluster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchHandloomClusterList')
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/handloomCluster/actions.js